import { render, staticRenderFns } from "./ListPurchaseOrderHistories.vue?vue&type=template&id=be4cb742&scoped=true&"
import script from "./ListPurchaseOrderHistories.vue?vue&type=script&lang=ts&"
export * from "./ListPurchaseOrderHistories.vue?vue&type=script&lang=ts&"
import style0 from "./ListPurchaseOrderHistories.vue?vue&type=style&index=0&id=be4cb742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4cb742",
  null
  
)

export default component.exports